export default __webpack_public_path__ + "icon-comment.676ccc2f.png";